import { getActionPlansIcon, getAgileResearchIcon, getMECIcon, getProgramIcon, getSurveySignalIcon, getTeamIcon } from '../../visual-elements/application-menu/icons';
// returns SVG icon markup as string
export const getApplicationMenuLogoByApplicationType = (applicationType) => {
    switch (applicationType) {
        case 'ACTION_PLAN':
            return getActionPlansIcon();
        case 'AD_HOC':
            return getSurveySignalIcon();
        case 'EX_360':
            return getTeamIcon();
        case 'EXPERIENCE_PROGRAMS':
            return getProgramIcon();
        case 'MEC':
            return getMECIcon();
        case 'AGILE_RESEARCH':
            return getAgileResearchIcon();
        default:
            return null;
    }
};
